__turbopack_context__.v({
  "card": "day-card-module__lKACJq__card",
  "description": "day-card-module__lKACJq__description",
  "image": "day-card-module__lKACJq__image",
  "kind": "day-card-module__lKACJq__kind",
  "link": "day-card-module__lKACJq__link",
  "media": "day-card-module__lKACJq__media",
  "subtitle": "day-card-module__lKACJq__subtitle",
  "text": "day-card-module__lKACJq__text",
  "title": "day-card-module__lKACJq__title",
});
